import {
  INFO_BOX_SINGLE,
  PRICE_BOX_SINGLE,
  WEIGHT_BOX_SINGLE,
  SIZE_BOX_SINGLE,
  WIDTH_BOX_SINGLE,
  HEIGHT_BOX_SINGLE,
  LENGTH_BOX_SINGLE,
  NEED_BOX_SINGLE,
  FACTOR_BOX_SINGLE,
  NOTIFICATION_BOX_SINGLE,
  TRADEMARK_BOX_SINGLE,
  BREAKABLE_BOX_SINGLE,
  LIQUID_BOX_SINGLE,
  PAYMENT_TYPE_BOX_SINGLE,
  AGENT_SERVICES_BOX_SINGLE,
  POST_TYPE_BOX_SINGLE,
  SHIPMENT_TYPE_BOX_SINGLE,
  IS_WORKED_BOX_SINGLE,
  SHIPMENT_IMAGES_BOX_SINGLE,
  IS_Insurance_BOX_SINGLE
} from "../../Types";

export const setInfoBox = (payload) => {
  return {
    type: INFO_BOX_SINGLE,
    payload: payload,
  };
};
export const setPriceBox = (payload) => {
  return {
    type: PRICE_BOX_SINGLE,
    payload: payload,
  };
};
export const setWeightBox = (payload) => {
  return {
    type: WEIGHT_BOX_SINGLE,
    payload: payload,
  };
};
export const setSizeBox = (payload) => {
  return {
    type: SIZE_BOX_SINGLE,
    payload: payload,
  };
};
export const setWidthBox = (payload) => {
  return {
    type: WIDTH_BOX_SINGLE,
    payload: payload,
  };
};
export const setHeightBox = (payload) => {
  return {
    type: HEIGHT_BOX_SINGLE,
    payload: payload,
  };
};
export const setLengthBox = (payload) => {
  return {
    type: LENGTH_BOX_SINGLE,
    payload: payload,
  };
};
export const setNeedBox = (payload) => {
  return {
    type: NEED_BOX_SINGLE,
    payload: payload,
  };
};
export const setFactorBox = (payload) => {
  return {
    type: FACTOR_BOX_SINGLE,
    payload: payload,
  };
};
export const setNotificationBox = (payload) => {
  return {
    type: NOTIFICATION_BOX_SINGLE,
    payload: payload,
  };
};
export const setTradeMarkBox = (payload) => {
  return {
    type: TRADEMARK_BOX_SINGLE,
    payload: payload,
  };
};
export const setBreakableBox = (payload) => {
  return {
    type: BREAKABLE_BOX_SINGLE,
    payload: payload,
  };
};
export const setLiquidBox = (payload) => {
  return {
    type: LIQUID_BOX_SINGLE,
    payload: payload,
  };
};
export const setPaymentTypeBox = (payload) => {
  return {
    type: PAYMENT_TYPE_BOX_SINGLE,
    payload: payload,
  };
};
export const setAgentServices = (payload) => {
  return {
    type: AGENT_SERVICES_BOX_SINGLE,
    payload: payload,
  };
};
export const setPostType = (payload) => {
  return {
    type: POST_TYPE_BOX_SINGLE,
    payload: payload,
  };
};
export const setShipmentType = (payload) => {
  return {
    type: SHIPMENT_TYPE_BOX_SINGLE,
    payload: payload,
  };
};
export const setIsWorked = (payload) => {
  return {
    type: IS_WORKED_BOX_SINGLE,
    payload: payload,
  };
};
export const setIsInsurance = (payload) => {
  return {
    type: IS_Insurance_BOX_SINGLE,
    payload: payload,
  };
};
export const setShipmentImages = (payload) => {
  return {
    type: SHIPMENT_IMAGES_BOX_SINGLE,
    payload: payload,
  };
};

